import { Work } from "../types";

const WORKS:Work[] = [
  {
    image: 'youtube',
    year: 2023,
    title: 'YouTube Clone',
    // desc: 'Статичный блог с интегрированным MDX',
    tags: ['Next.js', 'TypeScript', 'YouTube API', 'Zustand', 'React Query', 'Redis'],
    links: {
      demo: 'https://youtube-clone-master.vercel.app',
      repo: 'https://github.com/bogachenkov/youtube-clone'
    }
  },
  {
    image: 'dev.lifetime',
    year: 2022,
    title: 'Lifetime+ (SSR/SSG)',
    desc: 'Updated version of the website written in Next.js',
    tags: ['Next.js', 'TypeScript', 'SWR', 'Yandex Maps'],
    links: {
      demo: 'https://new.dev.lifetime.plus',
    }
  },
  {
    image: 'lifetime',
    year: 2021,
    title: 'Lifetime+ (SPA)',
    desc: 'The latest version of the Lifetime+ website, a digital lab that lets you test at home.',
    tags: ['React', 'TypeScript', 'Redux', 'Yandex Maps', 'Prerender'],
    links: {
      demo: 'https://www.lifetime.plus',
    }
  },
  {
    image: 'blog',
    year: 2022,
    title: 'Weblog.',
    desc: 'A static blog with built-in MDX',
    tags: ['Next.js', 'TypeScript', 'MDX', 'E2E Tests', 'Unit Tests'],
    links: {
      demo: 'https://next-static-mdx-blog.vercel.app',
      repo: 'https://github.com/bogachenkov/next-static-mdx-blog'
    }
  },
  {
    image: 'beauty-point',
    year: 2020,
    title: 'Beauty Point',
    desc: 'Time-slot control panel for beauty salon',
    tags: ['React', 'Redux', 'Pure CSS Grid'],
    links: {
      demo: 'https://bogachenkov.github.io/beauty-point',
      repo: 'https://github.com/bogachenkov/beauty-point/tree/master'
    }
  },
  {
    image: 'api',
    year: 2020,
    title: 'Api Query',
    desc: 'A simple console for use with JSON-queries.',
    tags: ['React', 'TypeScript', 'Monaco Editor'],
    links: {
      demo: 'https://bogachenkov.github.io/api-query',
      repo: 'https://github.com/bogachenkov/api-query'
    }
  },
  // {
  //   image: '',
  //   year: 2019,
  //   title: 'Поиск правонарушений для УГИБДД',
  //   desc: 'Система поиска фотофиксаций, разработанная для УГИБДД по Чеченской Республике',
  //   tags: ['React', 'Redux', 'TypeScript', 'Koa.js', 'Oracle'],
  // },
  {
    image: 'gmail',
    year: 2018,
    title: 'GMail Clone',
    tags: ['React', 'Redux', 'Transition Group'],
    links: {
      demo: 'https://bogachenkov.github.io/gmail-redesign',
      repo: 'https://github.com/bogachenkov/gmail-redesign'
    }
  },
  {
    image: 'dropbox',
    year: 2018,
    title: 'Dropbox Clone',
    tags: ['React', 'Redux', 'Transition Group'],
    links: {
      demo: 'https://bogachenkov.github.io/dropbox-redesign',
      repo: 'https://github.com/bogachenkov/dropbox-redesign'
    }
  },
];

export default WORKS;